import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import TickIcon from '@material-ui/icons/CheckCircle';

const useStyles = makeStyles(theme => ({
  container: {
    marginRight: '1rem',
    padding: 5,
    minWidth: '10rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: 'solid 2px #b5b5b5',
    borderRadius: 4,
    paddingTop: 10, // room for icon
    paddingBottom: 10,
    color: theme.palette.text.disabled,
    '&.selected': {
      borderColor: theme.palette.primary.light,
      color: theme.palette.text.primary,
    },
  },
  line1: {
    lineHeight: 1.2,
  },
  line2: {
    lineHeight: 2,
  },
  line3: {
    lineHeight: 1.2,
  },
  amount: {
    fontSize: '1.5rem',
  },
  period: {
    fontSize: '1.0rem',
  },
  info: {
    fontSize: '1.2rem',
  },
  icon: {
    color: 'green',
    position: 'absolute',
    top: 1,
    right: 2,
  },
}));

const PlanCard = ({plan, selected, onClick}) => {
  const classes = useStyles();
  const containerClass = selected ? `${classes.container} selected` : classes.container;
  const [title, amount, period, info] = plan.description;
  return (
    <ButtonBase className={containerClass} onClick={onClick}>
      {selected && <TickIcon className={classes.icon}/>}
      <div className={classes.line1}>{title}</div>
      <div className={classes.line2}>
        <span className={classes.amount}>{amount}</span>
        <span className={classes.period}>{period}</span>
      </div>
      <div className={classes.line3}>&nbsp;{info}</div>
    </ButtonBase>
  );
};

PlanCard.propTypes = {
  plan: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PlanCard;
